import Navbar from "../components/Navbar";
import BackButton from "../components/BackButton";
import BottomNav from "../components/BottomNav";
import { Sparkles, Heart, Bookmark, Play } from "lucide-react";

// Placeholder — real integration reads Growth AI content library once creators start publishing.
const VIDEOS = [
  { id: "v1", title: "POV: my first £1k month", creator: "@lucyfits", niche: "Fitness", views: "12.4k" },
  { id: "v2", title: "3 UGC opening hooks that keep working", creator: "@ada.creates", niche: "Beauty", views: "28.1k" },
  { id: "v3", title: "How I turn one shoot into 12 posts", creator: "@harveymakes", niche: "Lifestyle", views: "8.7k" },
  { id: "v4", title: "Deep-cleaning my kitchen — brand fit ideas", creator: "@primalpaige", niche: "Home", views: "41.9k" },
  { id: "v5", title: "Reels I'd make for a sustainable brand", creator: "@sofiabuild", niche: "Sustainability", views: "6.2k" },
  { id: "v6", title: "Fashion Reel — outfit-of-the-week formula", creator: "@nooralook", niche: "Fashion", views: "22.7k" },
];

const COLORS = ["from-nexus-pink/40 to-nexus-purple/40", "from-nexus-blue/40 to-nexus-purple/40", "from-nexus-purple/40 to-nexus-pink/40"];

export default function Inspiration() {
  return (
    <div className="min-h-screen grain">
      <Navbar />
      <div className="max-w-6xl mx-auto px-6 lg:px-10 pt-6">
        <BackButton fallback="/creator" label="Back" />
      </div>
      <div className="max-w-6xl mx-auto px-6 lg:px-10 pt-4 pb-24 space-y-8">
        <div>
          <div className="text-xs uppercase tracking-[0.3em] text-zinc-500 mb-2 flex items-center gap-2">
            <Sparkles className="h-4 w-4 text-nexus-pink" /> Inspiration Hub
          </div>
          <h1 className="font-display font-bold text-4xl md:text-5xl tracking-tighter">
            The best of <span className="nexus-gradient-text">our creators.</span>
          </h1>
          <p className="text-zinc-400 mt-2 max-w-2xl">
            Steal the format, not the idea. A rolling gallery of the top-performing content on Nexus, curated weekly.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4" data-testid="inspiration-gallery">
          {VIDEOS.map((v, i) => (
            <div key={v.id} className="group relative aspect-[9/16] rounded-2xl overflow-hidden hairline card-hover cursor-pointer" data-testid={`inspiration-video-${v.id}`}>
              <div className={`absolute inset-0 bg-gradient-to-br ${COLORS[i % COLORS.length]}`} />
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(255,255,255,0.2),transparent_70%)]" />
              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                <div className="h-14 w-14 rounded-full bg-white/20 backdrop-blur flex items-center justify-center">
                  <Play className="h-6 w-6 text-white ml-1" fill="white" />
                </div>
              </div>
              <div className="absolute inset-x-0 bottom-0 p-3 bg-gradient-to-t from-black/80 to-transparent">
                <div className="text-xs font-semibold text-white line-clamp-2">{v.title}</div>
                <div className="text-[10px] text-zinc-300 mt-1 flex items-center justify-between">
                  <span>{v.creator}</span>
                  <span>{v.views}</span>
                </div>
              </div>
              <div className="absolute top-2 right-2 flex flex-col gap-1.5 opacity-0 group-hover:opacity-100 transition-opacity">
                <button className="h-8 w-8 rounded-full bg-black/40 backdrop-blur text-white flex items-center justify-center hover:bg-black/60"><Heart className="h-3.5 w-3.5" /></button>
                <button className="h-8 w-8 rounded-full bg-black/40 backdrop-blur text-white flex items-center justify-center hover:bg-black/60"><Bookmark className="h-3.5 w-3.5" /></button>
              </div>
              <div className="absolute top-2 left-2 text-[9px] uppercase tracking-widest px-2 py-0.5 rounded-full bg-black/40 backdrop-blur text-white">
                {v.niche}
              </div>
            </div>
          ))}
        </div>
      </div>
      <BottomNav />
    </div>
  );
}
